import { ChannelPayloadFilter, ViewStream } from "spyne";
import { CodeGeneratorHolder } from "@franciscobatista/spyne-plugin-code-playground";
import { CodeContainerDetails } from "../code-examples/code-container-details";
import { CodePlaygroundMenu } from "components/code-playground/code-playground-menu";
import { CodeContainerTraits } from "traits/code-container-traits";
import { ScriptContentHolder } from "components/code-examples/script-content/script-content-holder";
import { CodeContainerProperties } from "components/code-examples/code-container-properties";
import { CodePlaygroundNavArrowBtns } from 'components/code-playground/code-playground-nav-arrow-btns';
import {UtilTraits} from 'traits/util-traits';

export class CodePlaygroundContainer extends ViewStream {
  constructor(props = {}) {
    props.id = "code-container";

    props.class = `code-container code-container-${props.codeBlockId} page-${props.pageId}`;
    props.codeBlockDataSection ??= "types";
    props.template = require("./template/code-container-playground.tmpl.html");

    super(props);
  }

  addActionListeners() {
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (p) => p.parentVsid === this.props.vsid,
    });

    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === this.props.codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_CODE_REVEAL_EVENT",
        "onCodeContainerRevealEvent",
        isContainerFilter,
      ],
      ["CHANNEL_SPYNE_DOCS_DATA_LOADED_EVENT", "onDataLoaded"],
      ["CHANNEL_CODE_GEN_DATA.*_EVENT", "onCodeLoaded", isContainerFilter],
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeContainerUpdateEvent",
        isCodeBlockIdFilter,
      ],
    ];
  }
  onCodeContainerRevealEvent(e) {
    const { scriptNum } = e.payload;
   //console.log("SCRIPT NUM ", { scriptNum }, e);
    const isScriptContent = parseInt(scriptNum) > 0;
    this.props.el$.toggle("is-script-content", isScriptContent);
  }

  checkForDocsHelloWorldException(data) {
      const {codeBlockId, methodName} = data;

      if (codeBlockId !=='define'){
        return;
      }
    const methodStr = methodName === "codeplaygroundAttr$Default" ? "min-height:244px;" : "";

      const updateMinHeightForCodeGenHolder = (codeBlockId, methodName)=>{
        if (this.props && this.props.el$('#code-generator-holder').exists){
          this.props.el$('#code-generator-holder').el.style.cssText = methodStr;
        }


      }


      const codeGenHolder$ =  this.props.el$('#code-generator-holder');

      if (this.props && codeGenHolder$.exists){
        updateMinHeightForCodeGenHolder();
      } else {
        window.setTimeout(updateMinHeightForCodeGenHolder, 500);
      }


    //console.log("PAYLOAD HELLO WORLD ",{codeBlockId,methodStr, methodName, data}, this.props.el$('#code-generator-holder').el);
  }

  onChannelCodeContainerUpdateEvent(e) {
    const { isStaticExample, hideCodeSample } = e.payload;

    const isStaticClass = String(isStaticExample) === "true";

    const isHideCodeSample = String(hideCodeSample) === "true";
    //console.log("CODE CONTAINER UPDATED ",e, {isStaticClass});

    this.props
      .el$(".code-container-content-holder")
      .toggle("static-example", isStaticClass);

    this.props
    .el$(".code-container-content-holder")
    .toggle("hide-code-example", isHideCodeSample);


    this.props.el$.removeClass("is-script-content");
    if (this.props.el$("#code-generator-holder").exists) {
      this.props.el$("#code-generator-holder").el.scrollTo(0, 0);
    }

    this.checkForDocsHelloWorldException(e.payload);
    //console.log("E IS code update ",{isStaticExample,isStaticClass, e});
  }

  onCodeLoaded(e) {
    const { scriptContentArr, parentVsid, codeBlockId } = e.payload;
    const hasScriptContentBool = scriptContentArr.length > 0;

   //console.log(this.props.vsid," SCRIPT CONTENT!!!! ", {scriptContentArr}, e.action, e.payload);

    if (hasScriptContentBool === true) {
      this.appendView(
        new ScriptContentHolder({
          data: scriptContentArr,
          parentVsid,
          codeBlockId,
        }),
        "#code-generator-holder",
      );

      this.props
        .el$("div.code-snippet")
        .toggleClass("adjust-for-tabs", hasScriptContentBool);
    }




  }

  onDataLoaded(e) {
    const { payload } = e;
    const { codeBlockDataSection } = this.props;

    //console.log("data loaded external ",this.props.codeBlockId, this.props.codeBlockDataSection, payload.codeGenData);
    const data = CodeContainerTraits.codeContainer$GetCodBlockById(
      this.props.codeBlockId,
      payload.codeGenData[codeBlockDataSection],
    );

    this.props.el$("div.code-snippet").removeClass("adjust-for-tabs");

    this.props.data = data;
    const { setToColumns } = data;
    this.props.el$.toggle("column-layout", String(setToColumns) === "true");
    //console.log('data is ',data);
    const typeClassStr = `playground-code-container-${UtilTraits.util$ToKebabCase(this.props.data.codeBlockId)}`

    this.props.el$.addClass(typeClassStr);


    const { codeBlockId } = this.props;
   //console.log("CONTAINER DATA ", {setToColumns, data});

    // const codeGenData = safeClone(payload.codeGenData);
    this.appendView(
      new CodePlaygroundMenu({ data, codeBlockId, codeBlockDataSection }),
      ".menu-holder",
    );
  }

  broadcastEvents() {
    // return nexted array( s)
    return [];
  }

  onRendered() {
    this.props.codeContentHolder$ = this.props.el$(
      ".code-container-content-holder",
    );

    this.addChannel("CHANNEL_SPYNE_DOCS_DATA");
    this.addChannel("CHANNEL_CODE_GEN");
    this.addChannel("CHANNEL_CODE_CONTAINER");

    const parentVsid = this.props.vsid;
    const { codeBlockId, pageId } = this.props;




    //console.log("PLAYGROUND ",this.props);

    if (pageId === "reference") {
      this.prependView(
        new CodeContainerProperties({ parentVsid, pageId, codeBlockId }),
        ".code-container-reference-holder",
      );
    }

    this.appendView(
      new CodeGeneratorHolder({ parentVsid, pageId, codeBlockId }),
      ".code-container-content-holder",
    );
    this.appendView(
      new CodeContainerDetails({ parentVsid, pageId, codeBlockId }),
      ".code-container-content-holder",
    );
    if (codeBlockId === 'define'){
      this.prependView(new CodePlaygroundNavArrowBtns({data:this.props.data}), '.code-container-reference-holder');
    }

  }
}
